import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AlphaSummary from '../components/AlphaSummary';
import AttendanceSummary from '../components/AttendanceSummary';

export default function TrackGLA() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('labs');
  const [showAlphaSummary, setShowAlphaSummary] = useState(false);
  const [showBetaSummary, setShowBetaSummary] = useState(false);
  const [showCharlieSummary, setShowCharlieSummary] = useState(false);
  const [showDeltaSummary, setShowDeltaSummary] = useState(false);
  const [showEchoSummary, setShowEchoSummary] = useState(false);
  const [showAttendanceSummary, setShowAttendanceSummary] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);

  // Fetch attendance data from API
  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await fetch(`/api/gla/attendance-summary`);
        const result = await response.json();
        
        if (result.success) {
          setAttendanceData(result.data.map((item, idx) => ({
            id: idx + 1,
            week: idx + 1,
            title: `Week ${idx + 1} Attendance`,
            status: 'closed',
            responses: result.data.length
          })));
        } else {
          throw new Error(result.message || 'Failed to fetch attendance data');
        }
      } catch (err) {
        console.error('Error fetching attendance data:', err);
        // Fall back to default data on error
        setAttendanceData([
          { id: 1, week: 1, title: 'Week 1 Attendance', status: 'open', responses: 24 },
          { id: 2, week: 2, title: 'Week 2 Attendance', status: 'closed', responses: 22 },
          { id: 3, week: 3, title: 'Week 3 Attendance', status: 'closed', responses: 20 },
          { id: 4, week: 4, title: 'Week 4 Attendance', status: 'closed', responses: 23 },
          { id: 5, week: 5, title: 'Week 5 Attendance', status: 'closed', responses: 21 },
          { id: 6, week: 6, title: 'Week 6 Attendance', status: 'closed', responses: 19 },
          { id: 7, week: 7, title: 'Week 7 Attendance', status: 'closed', responses: 18 },
          { id: 8, week: 8, title: 'Week 8 Attendance', status: 'closed', responses: 25 },
          { id: 9, week: 9, title: 'Week 9 Attendance', status: 'closed', responses: 20 }
        ]);
      }
    };

    fetchAttendanceData();
  }, []);

  // Labs data
  const labsData = [
    { id: 1, week: 1, group: 'Alpha', title: 'Foundation Concepts - Alpha', status: 'released', submissions: 24 },
    { id: 2, week: 1, group: 'Beta', title: 'Foundation Concepts - Beta', status: 'released', submissions: 22 },
    { id: 3, week: 1, group: 'Charlie', title: 'Foundation Concepts - Charlie', status: 'released', submissions: 20 },
    { id: 4, week: 2, group: 'Alpha', title: 'Intermediate Topics - Alpha', status: 'released', submissions: 23 },
    { id: 5, week: 2, group: 'Beta', title: 'Intermediate Topics - Beta', status: 'released', submissions: 21 },
    { id: 6, week: 2, group: 'Charlie', title: 'Intermediate Topics - Charlie', status: 'closed', submissions: 19 },
    { id: 7, week: 3, group: 'Alpha', title: 'Advanced Techniques - Alpha', status: 'closed', submissions: 18 },
    { id: 8, week: 3, group: 'Beta', title: 'Advanced Techniques - Beta', status: 'closed', submissions: 17 },
    { id: 9, week: 3, group: 'Charlie', title: 'Advanced Techniques - Charlie', status: 'closed', submissions: 16 }
  ];

  const currentData = selectedType === 'attendance' ? attendanceData : labsData;

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '3rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: '#1a1a1a',
                border: 'none',
                color: 'white',
                padding: '0.6rem 0.8rem',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '1.1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 300ms ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#2d2d2d';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#1a1a1a';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <i className="fas fa-arrow-left"></i>
            </button>
            <div>
              <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0' }}>
                <i className="fas fa-chart-bar" style={{ marginRight: '1rem', color: '#1a1a1a' }}></i>
                Track GLA
              </h1>
              <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
                Monitor and track all GLA activities and submissions
              </p>
            </div>
          </div>

          {/* Dropdown */}
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '2px solid #7A5107',
              borderRadius: '6px',
              fontFamily: 'inherit',
              fontSize: '1rem',
              background: 'white',
              color: '#1a1a1a',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 300ms ease'
            }}
            onMouseOver={(e) => {
              e.target.style.borderColor = '#5a3a05';
            }}
            onMouseOut={(e) => {
              e.target.style.borderColor = '#7A5107';
            }}
          >
            <option value="labs">Manage Weekly Labs</option>
            <option value="attendance">Manage Attendance</option>
          </select>
        </div>

        {/* Description */}
        <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #e8e8e8' }}>
          <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem', fontWeight: 700, color: '#1a1a1a' }}>
            {selectedType === 'attendance' ? 'Manage Attendance' : 'Manage Weekly Labs'}
          </h3>
          <p style={{ margin: 0, color: '#666', fontSize: '0.95rem' }}>
            {selectedType === 'attendance' ? 'Open, close, and manage weekly attendance forms' : 'Add, release, and manage your lab content'}
          </p>
        </div>

        {/* Items List */}
        {selectedType === 'labs' && (
          <div style={{ marginBottom: '2rem', padding: '1rem', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #e8e8e8' }}>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap', marginBottom: '1rem' }}>
              <button
                onClick={() => setShowAlphaSummary(true)}
                style={{
                  background: '#7A5107',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  transition: 'all 300ms ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => e.target.style.background = '#5a3a05'}
                onMouseOut={(e) => e.target.style.background = '#7A5107'}
              >
                <i className="fas fa-table"></i>
                Alpha Summary
              </button>
              <button
                onClick={() => setShowBetaSummary(true)}
                style={{
                  background: '#7A5107',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  transition: 'all 300ms ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => e.target.style.background = '#5a3a05'}
                onMouseOut={(e) => e.target.style.background = '#7A5107'}
              >
                <i className="fas fa-table"></i>
                Beta Summary
              </button>
              <button
                onClick={() => setShowCharlieSummary(true)}
                style={{
                  background: '#7A5107',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  transition: 'all 300ms ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => e.target.style.background = '#5a3a05'}
                onMouseOut={(e) => e.target.style.background = '#7A5107'}
              >
                <i className="fas fa-table"></i>
                Charlie Summary
              </button>
              <button
                onClick={() => setShowDeltaSummary(true)}
                style={{
                  background: '#7A5107',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  transition: 'all 300ms ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => e.target.style.background = '#5a3a05'}
                onMouseOut={(e) => e.target.style.background = '#7A5107'}
              >
                <i className="fas fa-table"></i>
                Delta Summary
              </button>
              <button
                onClick={() => setShowEchoSummary(true)}
                style={{
                  background: '#7A5107',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  transition: 'all 300ms ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => e.target.style.background = '#5a3a05'}
                onMouseOut={(e) => e.target.style.background = '#7A5107'}
              >
                <i className="fas fa-table"></i>
                Echo Summary
              </button>
            </div>
            <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>
              View consolidated GL scores across all 9 weeks with averages
            </p>
          </div>
        )}

        {selectedType === 'attendance' && (
          <>
            <div style={{ marginBottom: '2rem', padding: '1rem', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #e8e8e8' }}>
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap', marginBottom: '1rem' }}>
                <button
                  onClick={() => setShowAttendanceSummary(true)}
                  style={{
                    background: '#7A5107',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: 700,
                    transition: 'all 300ms ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseOver={(e) => e.target.style.background = '#5a3a05'}
                  onMouseOut={(e) => e.target.style.background = '#7A5107'}
                >
                  <i className="fas fa-table"></i>
                  Attendance Summary
                </button>
              </div>
              <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>
                View student attendance across all 9 weeks with detailed scores
              </p>
            </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1rem' }}>
            {currentData.map((item) => (
              <div
                key={item.id}
                style={{
                  background: selectedType === 'labs' ? '#dcdcdc' : '#f5f5f5',
                  border: selectedType === 'labs' ? '1px solid #c0c0c0' : '1px solid #e8e8e8',
                  borderRadius: '6px',
                  padding: '1rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  transition: 'all 300ms ease',
                  minHeight: '60px'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ flex: 1 }}>
                  <h4 style={{ margin: '0 0 0.25rem 0', fontSize: '1rem', fontWeight: 700, color: '#1a1a1a' }}>
                    {selectedType === 'attendance' ? item.title : `${item.title}`}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>
                    {selectedType === 'attendance' ? (
                      <>Week {item.week} • Status: <span style={{ fontWeight: 600, color: item.status === 'open' ? '#2e7d32' : '#c62828' }}>{item.status === 'open' ? 'Open' : 'Closed'}</span> • Responses: {item.responses}</>
                    ) : (
                      <>Week {item.week} • {item.group} • Submissions: <span style={{ fontWeight: 600 }}>{item.submissions}</span></>
                    )}
                  </p>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '1rem' }}>
                  <span style={{
                    background: selectedType === 'attendance' ? (item.status === 'open' ? '#e8f5e9' : '#ffebee') : (item.status === 'released' ? '#e8f5e9' : '#ffebee'),
                    color: selectedType === 'attendance' ? (item.status === 'open' ? '#2e7d32' : '#c62828') : (item.status === 'released' ? '#2e7d32' : '#c62828'),
                    padding: '0.4rem 0.8rem',
                    borderRadius: '20px',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                    whiteSpace: 'nowrap'
                  }}>
                    {selectedType === 'attendance' ? (item.status === 'open' ? '● Open' : '● Closed') : (item.status === 'released' ? '● Released' : '● Closed')}
                  </span>
                  <i className="fas fa-chevron-right" style={{ color: '#999', fontSize: '1rem' }}></i>
                </div>
              </div>
            ))}
          </div>
          </>
        )}
        {/* Alpha Summary Modal */}
        {showAlphaSummary && <AlphaSummary group="alpha" onClose={() => setShowAlphaSummary(false)} />}
      {showBetaSummary && <AlphaSummary group="beta" onClose={() => setShowBetaSummary(false)} />}
      {showCharlieSummary && <AlphaSummary group="charlie" onClose={() => setShowCharlieSummary(false)} />}
      {showDeltaSummary && <AlphaSummary group="delta" onClose={() => setShowDeltaSummary(false)} />}
      {showEchoSummary && <AlphaSummary group="echo" onClose={() => setShowEchoSummary(false)} />}
      {showAttendanceSummary && <AttendanceSummary onClose={() => setShowAttendanceSummary(false)} />}      </div>
    </div>
  );
}
